import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import UploadImageField from '../../../components/UploadImageField';
import ValidatesFormWith from '../../../utils/ValidatesFormWith';
import validationSchema from './validation';
import MongoObjectID from '../../../utils/MongoObjectID';


class ConfigurationForm extends PureComponent {
  process = (values) => {
    const images = values.images.map(i => i.url);
    this.props.onSubmit(images);
  };

  render() {
    const {
      configuration,
    } = this.props;

    let images = null;
    if (configuration) {
      images = configuration.find(c => c.key === 'main_slideshow');
      if (images && images.value) {
        images = images.value.map(i => ({
          id: MongoObjectID(),
          url: i,
        }));
      } else {
        images = null;
      }
    }


    return (
      <Formik
        enableReinitialize
        initialValues={{
          images,
        }}
        onSubmit={this.process}
        validate={ValidatesFormWith(validationSchema)}
        render={props => (
          <form onSubmit={props.handleSubmit}>
            <div className="search-contents-sidebar">
              <div className="row">
                <div className="col-md-12">
                  <UploadImageField
                    label="Imágenes"
                    name="images"
                  />
                </div>
              </div>
              <div className="m-b-md m-t-md">
                <button type="submit" className="book-btn">
                  <span className="book-btn-l">
                    <i className="fa fa-save" />
                  </span>
                  <span className="book-btn-r">Guardar</span>
                  <div className="clear" />
                </button>
              </div>
            </div>
          </form>
        )}
      />
    );
  }
}

ConfigurationForm.propTypes = {
  configuration: PropTypes.array,
  onSubmit: PropTypes.func,
};

ConfigurationForm.defaultProps = {
  configuration: [],
  onSubmit: () => {},
};

export default ConfigurationForm;



// WEBPACK FOOTER //
// ./src/containers/Admin/Configuration/form.js